import { create } from "zustand";
import type { Session, User } from "@supabase/supabase-js";
import { supabase } from "@/lib/supabase";
/**
* Estado de autenticación global.
*
* - `loading` arranca en true hasta que `init()` hace getSession() inicial.
* Esto evita un flash de "no autenticado → autenticado" al abrir la app.
* - `onAuthStateChange` mantiene `session`/`user` sincronizados cuando el
* token se refresca solo o cuando el usuario hace logout en otra tab.
* - `init()` debe llamarse UNA sola vez al montar la app (en App.tsx).
*/
interface AuthState {
session: Session | null;
user: User | null;
loading: boolean;
initialized: boolean;
init: () => () => void;
signOut: () => Promise<void>;
}
export const useAuthStore = create<AuthState>((set, get) => ({
session: null,
user: null,
loading: true,
initialized: false,
init: () => {
if (get().initialized) {
return () => undefined;
}
set({ initialized: true });
void supabase.auth.getSession().then(({ data }) => {
set({
session: data.session,
user: data.session?.user ?? null,
loading: false,
});
});
const { data: sub } = supabase.auth.onAuthStateChange((_event, session) => {
set({
session,
user: session?.user ?? null,
loading: false,
});
});
return () => sub.subscription.unsubscribe();
},
signOut: async () => {
await supabase.auth.signOut();
set({ session: null, user: null });
},
}));
